import { useAdminInvoiceReportsSearch } from '@/context/services/admin_invoice_reports/AdminInvoiceReports.service';
import type {
  AdminInvoiceReportsSearchQuery,
  FetchAdminInvoiceReportsArgs,
  OrderByItem,
} from '@/features/admin_invoice_reports/types';

export const useAdminInvoiceReportsSearchData = (
  args: FetchAdminInvoiceReportsArgs = {}
) => {
  const { data, pagination, refetch, isFetching, isError, error } =
    useAdminInvoiceReportsSearch(args);

  return { data, pagination, refetch, isFetching, isError, error };
};

export type { AdminInvoiceReportsSearchQuery, OrderByItem };
